<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>

    <el-form ref="form" :model="formData" label-width="150px">
      <div>
        <span class="group-title">门店基础信息</span>
        <el-form-item label="门店名称" prop="storeName" :rules="rules">
          <el-input
              style="width: 400px"
              v-model="formData.storeName"
              placeholder="请输入"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店类型" prop="storeType" :rules="rules">
          <el-select
              style="width: 400px"
              v-model="formData.storeType"
              placeholder="请选择"
              size="small"
              clearable
              :disabled="storeTypeDisabled"
          >
            <el-option
                v-for="item in dict_store_type"
                :key="item.value"
                :label="item.name"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
            v-if="canEditAreaFollowUser"
            label="区域跟进人"
            prop="areaFollowUserId"
            :rules="rules"
        >
          <SelectAdminUser
              v-model="formData.areaFollowUserId"
              :job-code="AdminJobCode.A001"
              style="width: 400px"
          />
        </el-form-item>
        <el-form-item label="门店标签" prop="storeTagList">
          <div class="store-tags">
            <el-tag
                :key="tag"
                v-for="tag in formData.storeTagList"
                :disable-transitions="false"
                closable
                @close="handleCloseTag(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="tagInputVisible"
                v-model="tagInputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleTagInputConfirm"
                @blur="handleTagInputConfirm"
            >
            </el-input>
            <el-button
                v-else
                class="button-new-tag"
                size="small"
                @click="showTagInput"
            >+ 新增标签</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="负责人姓名" prop="legalName">
          <el-input
              style="width: 400px"
              v-model="formData.legalName"
              placeholder="请输入"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="负责人手机号" prop="legalMobile">
          <el-input
              style="width: 400px"
              v-model="formData.legalMobile"
              placeholder="请输入"
              size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="门头照片" prop="facadeImageList" :rules="rules">
          <FileUpload
              :isMulti="true"
              :name.sync="formData.facadeImageList"
              :url="formData.facadeImageUrlList"
          ></FileUpload>
        </el-form-item>
        <el-form-item label="所在地区" prop="regionIdList" :rules="districtRule">
          <AreaSelector
              style="width: 400px"
              size="small"
              v-model="formData.regionIdList"
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="addressDetail" :rules="rules">
          <el-input
              style="width: 400px"
              type="textarea"
              v-model="formData.addressDetail"
          ></el-input>
        </el-form-item>
      </div>
      <div>
        <span class="group-title">门店资质信息</span>
        <el-form-item label="营业执照" prop="licenseImage" :rules="rules">
          <FileUpload
              :name.sync="formData.licenseImage"
              :url="formData.licenseImageUrl"
          ></FileUpload>
        </el-form-item>
        <el-form-item label="营业执照名称" prop="licenseName">
          <el-input
              style="width: 400px"
              v-model="formData.licenseName"
              placeholder="请输入营业执照名称"
              size="small"
              :disabled="disableSaLegalForm()"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="licenseCreditCode">
          <el-input
              style="width: 400px"
              v-model="formData.licenseCreditCode"
              placeholder="请输入统一社会信用代码"
              size="small"
              :disabled="disableSaLegalForm()"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="saLegalName">
          <el-input
              style="width: 400px"
              v-model="formData.saLegalName"
              placeholder="请输入姓名"
              size="small"
              :disabled="disableSaLegalForm()"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人手机号" prop="saLegalMobile">
          <el-input
              style="width: 400px"
              v-model="formData.saLegalMobile"
              placeholder="请输入手机号"
              size="small"
              :disabled="disableSaLegalForm()"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="saLegalIdCardNo">
          <el-input
              style="width: 400px"
              v-model="formData.saLegalIdCardNo"
              placeholder="请输入身份证号"
              size="small"
              :disabled="disableSaLegalForm()"
          ></el-input>
        </el-form-item>
      </div>

      <div>
        <span class="group-title">增值服务</span>
        <el-form-item label="保险金系数" prop="insuranceRate" :rules="rules">
          <el-input-number
              style="width: 400px"
              size="small"
              v-model="formData.insuranceRate"
              :precision="2"
              :step="0.01"
              :min="0"
          ></el-input-number>
          <span class="tip">注：保险金=零售价*保险金系数</span>
        </el-form-item>
        <el-form-item label="监管锁费" prop="lockAmount" :rules="rules">
          <el-input-number
              style="width: 400px"
              size="small"
              v-model="formData.lockAmount"
              :precision="2"
              :step="0.01"
              :min="0"
          ></el-input-number>
        </el-form-item>
      </div>

      <div>
        <span class="group-title">结算信息</span>
        <div>
          <span class="group-sub-title">商家转账</span>
          <el-form-item label="姓名" prop="payeeIdName">
            <el-input
                style="width: 400px"
                v-model="formData.payeeIdName"
                placeholder="请输入姓名"
                size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="支付宝账号" prop="payeeAlipayAccount">
            <el-input
                style="width: 400px"
                v-model="formData.payeeAlipayAccount"
                placeholder="请输入支付宝账号"
                size="small"
            ></el-input>
          </el-form-item>
        </div>

        <div v-if="formData.storeType === 1">
          <span class="group-sub-title">大订单结算</span>
          <el-form-item label="支付宝账号" prop="alipaySubMerchantLogonId">
            <el-input
                style="width: 400px"
                v-model="formData.alipaySubMerchantLogonId"
                placeholder="请输入支付宝账号"
                size="small"
                :disabled="disableSaLegalForm()"
            ></el-input>
          </el-form-item>
        </div>
      </div>

      <el-form-item label="">
        <el-button type="primary" size="small" @click="save">保存</el-button>
        <el-button type="" size="small" @click="closePage()">取消</el-button>
      </el-form-item>
    </el-form>
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import { getStoreEditDetailAPI, addStoreAPI, editStoreAPI } from "./api";
import FileUpload from "@/components/file-upload/index.vue";
import { dict_store_type } from "@/enum/dict/index.js";
import AreaSelector from "@/components/area-selector/index.vue";
import SelectAdminUser from "@/views/components/select-admin-user.vue";
import { AdminJobCode } from "@/enum/dict/index.js";

export default {
  name: "AddOrEdit",
  components: { FileUpload, SelectAdminUser, AreaSelector },
  computed: {
    canEditAreaFollowUser() {
      return this.formData.enableAreaFollowEdit === true;
    },
  },
  data() {
    return {
      AdminJobCode,
      dialogVisible: false,
      rules: [{ required: true, message: "该项不能为空", trigger: "blur" }],
      districtRule: [
        { required: true, message: "该项不能为空", trigger: "blur" },
        {
          validator: (rule, value, callback) => {
            if (!value || (Array.isArray(value) && value.length === 0)) {
              return callback(new Error("请选择地区"));
            }

            return callback();
          },
        },
      ],
      storeTypeDisabled: false,
      dict_store_type,
      formData: {
        storeName: "",
        enableAreaFollowEdit: false,
        areaFollowUserId: "",
        storeTagList: [],
        legalName: "",
        legalMobile: "",
        saLegalName: "",
        saLegalMobile: "",
        saLegalIdCardNo: "",
        licenseName: "",
        licenseCreditCode: "",
        licenseImage: "",
        facadeImageList: "",
        addressDetail: "",
        insuranceRate: 0,
        lockAmount: 0,
        settleType: 2,
        payeeIdName: "",
        payeeAlipayAccount: "",
        alipaySubMerchantLogonId: "",
        regionIdList: [],
      },
      tagInputVisible: false,
      tagInputValue: "",
      alipaySubMerchantStatus: 0,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getStoreDetail();
      this.storeTypeDisabled = true;
    }
  },
  methods: {
    disableSaLegalForm() {
      return this.alipaySubMerchantStatus === 1 || this.alipaySubMerchantStatus === 2;
    },
    closeCurrentTag() {
      this.$store.dispatch("tagsView/delView", this.$route).then(({ visitedViews }) => {
        const latestView = visitedViews.slice(-1)[0];

        if (latestView) {
          this.$router.push(latestView.fullPath);
          return;
        }

        this.$router.push("/store/list");
      });
    },
    closePage() {
      const isOpenedByWindow = window.opener && !window.opener.closed;

      if (isOpenedByWindow) {
        window.close();
        return;
      }

      this.closeCurrentTag();
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const submitData = {
            ...this.formData,
            districtId: this.formData.regionIdList[2],
            // 开关关闭时不提交区域跟进人变更
            areaFollowUserId: this.canEditAreaFollowUser
              ? this.formData.areaFollowUserId
              : undefined,
          };
          if (this.formData.id) {
            editStoreAPI(submitData).then(() => {
              this.$message.success("编辑成功");
              this.closePage();
            });
          } else {
            addStoreAPI(submitData).then(() => {
              this.$message.success("新增成功");
              this.closePage();
            });
          }
        }
      });
    },
    async getStoreDetail() {
      const detail = await getStoreEditDetailAPI(this.$route.params.id);
      this.formData = {
        ...detail,
        // 后端可能返回 0，前端下拉应视为未选择
        areaFollowUserId: detail?.areaFollowUserId || "",
      };
      this.alipaySubMerchantStatus = detail.alipaySubMerchantStatus || 0;
    },
    handleCloseTag(tag) {
      this.formData.storeTagList.splice(
        this.formData.storeTagList.indexOf(tag),
        1,
      );
    },
    showTagInput() {
      this.tagInputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleTagInputConfirm() {
      if (this.formData.storeTagList.length >= 5) {
        this.$message.error("标签不能超过5个");
        return;
      }
      let inputValue = this.tagInputValue;
      if (inputValue) {
        this.formData.storeTagList.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .tip {
    margin-left: 20px;
    color: #f56c6c;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
  .el-form-item {
    .el-form-item__label, .el-form-item__content {
      font-size: 13px;
      line-height: 30px;
    }

    .store-tags {
      width: 500px;
      .el-tag + .el-tag {
        margin-left: 10px;
      }
      .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
      }
      .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
      }
    }
  }

  .group-title {
    display: flex;
    font-size: 15px;
    font-weight: 700;
    margin: 30px 0;
    padding-left: 40px;
  }

  .group-sub-title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    margin: 10px 0;
    padding-left: 60px;
  }
}
</style>
